// extracted by mini-css-extract-plugin
export default {"elementItem":"ElementItem_elementItem__UKTtX","elementLogoContainer":"ElementItem_elementLogoContainer__bE1za","icon":"ElementItem_icon__9dTWL","text":"ElementItem_text__9zmDG"};